import type { GuidelineDraftContent } from '../types/accuracy';
import type { GuidelineChatProposal, GuidelineDiffHunk } from '../types/guidelineProposal';

function applyHunk(content: GuidelineDraftContent, hunk: GuidelineDiffHunk): void {
  const segments = hunk.pathLabel.split(' › ');
  if (segments.length < 2) return;
  const categoryId = segments[segments.length - 2];
  const ruleId = segments[segments.length - 1];
  const category = content.violation_categories.find((c) => c.id === categoryId);
  if (!category) return;
  const rule = category.rules.find((r) => r.id === ruleId) ?? category.rules[0];
  if (!rule) return;

  const newValue = hunk.added.join('\n').trim();
  if (!newValue) return;

  if (hunk.field === 'existence_check_prompt') {
    rule.existence_check_prompt = newValue;
  } else if (hunk.field === 'violation_check_prompt') {
    rule.violation_check_prompt = newValue;
  }
}

export function applyProposalToDraftContent(
  content: GuidelineDraftContent,
  proposal: GuidelineChatProposal
): GuidelineDraftContent {
  const next = JSON.parse(JSON.stringify(content)) as GuidelineDraftContent;
  for (const hunk of proposal.hunks) {
    applyHunk(next, hunk);
  }
  return next;
}
